import { createSlice } from '../wrappers';

interface IInventorySlice {
	confirmationVisible: boolean;
	finishScreenVisible: boolean;
	delZoneActive: boolean;
}

const initialState: IInventorySlice = {
	confirmationVisible: false,
	finishScreenVisible: false,
	delZoneActive: false,
};

const inventorySlice = createSlice({
	name: 'inventory',
	initialState,
	reducers: {
		setConfirmationVisible: (state, action: { payload: boolean }) => {
			state.confirmationVisible = action.payload;
		},
		setFinishScreenVisible: (state, action: { payload: boolean }) => {
			state.finishScreenVisible = action.payload;
		},
		resetInventoryState: (state) => {
			state.confirmationVisible = false;
			state.finishScreenVisible = false;
		},
		resetExchangeState: (state) => {
			state.confirmationVisible = false;
			state.finishScreenVisible = false;
		},
		setDelZoneActive: (state, action: { payload: boolean }) => {
			state.delZoneActive = action.payload;
		},
	},
});

export const {
	setConfirmationVisible,
	setFinishScreenVisible,
	resetInventoryState,
	resetExchangeState,
	setDelZoneActive,
} = inventorySlice.actions;
export default inventorySlice.reducer;
